import { SortOrder } from 'kentico-cloud-delivery';
import Client from '../services/kenticoClient';
import { KENTICO_TYPES, SETTINGS } from '../common/consts/kentico';

class NewsService {
  /**
   * Fetch news
   * Default parameters simlify getting data for most common news.
   * @param { object } options
   *    { number } limit (optional) Limit of items, for single response
   *    { number } page (optional) Which page of items to fetch e.g  page=2 gives items between 10 and 19 with limit 10
   *    { boolean } featured (optional) Queries for features items
   *    { number } publishYear (optional) Year extracted form publication date. If "null", query param is not set
   *
   * @returns { promise } Respolved to standard Kentico API response
   */
  async fetchNews({
    limit = SETTINGS.DEFAULT_LIMIT,
    skip = 0,
    featured = false,
    publishYear = null
  } = {}) {
    const query = Client.items()
      .type(KENTICO_TYPES.NEWS)
      .orderParameter('elements.data_publikacji', SortOrder.desc)
      .limitParameter(limit)
      .skipParameter(skip);

    if (featured) {
      query.equalsFilter('elements.promowany__promowany[any]', 'tak');
    }

    if (publishYear) {
      const dateFrom = `${publishYear}-01-01`;
      const dateTo = `${publishYear + 1}-01-01`;
      query.rangeFilter('elements.data_publikacji', dateFrom, dateTo);
    }
    return query.toPromise();
  }

  /**
   * Fetch single news by id
   * @param { string } id (required) Id of the object
   * @returns { promise } Resolved to standard Kentico API response
   */

  async getNewsById(id) {
    const query = Client.items()
      .depthParameter(2)
      .equalsFilter('system.id', id);

    return query.toPromise();
  }

  async getNewsBySlug(slug, lang) {
    const query = Client.kenticoItems()
      .type(KENTICO_TYPES.NEWS)
      .depthParameter(2)
      .equalsFilter('elements.slug', slug);
    if (lang) {
      query.languageParameter(lang);
    }

    return query.toPromise();
  }
}

export default new NewsService();



// WEBPACK FOOTER //
// ./src/services/News.service.js